// 合同页面接口
import axios from '@/utils/http'
import Url from './requestUrl'

// 获取当前登录用户的合同列表
export function getPageContract (params) {
  return axios({
    url: Url.getPageContractUrl,
    method: 'get',
    params
  })
}

// 合同预览接口
export function previewContract (params) {
  return axios({
    url: Url.previewContractUrl,
    method: 'get',
    params
  })
}

// 签约地址列表查询接口
export function querySignUrl (params) {
  return axios({
    url: Url.querySignUrl,
    method: 'get',
    params
  })
}

// 签署结果提交接口(所有签约方式共用)
export function contractSignResult (data) {
  return axios({
    url: Url.contractSignResultUrl,
    method: 'post',
    data
  })
}

// 查询当前合同签署所需要的参数、签约方式、条件和权限
export function contractPreSignQuery (params) {
  return axios({
    url: Url.contractPreSignQueryUrl,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/http/contract.js